import { connect } from 'react-redux';
import AuctionDetail from 'components/auctions/AuctionDetail';
import {
  clearImages,
  clearCurrentAuction,
  fetchAuction,
  startAuctions,
  endAuction,
  commentAuction,
  clearCommentAuction,
  cancelAuctions,
  createAuctionBids,
  fetchImages,
  fetchBidsForAuction,
  clearAuctionBids,
  acceptAuction,
  rejectAuction,
  dispatchAuction,
  fetchComments,
} from 'data/auctions/Auctions.actions';
import { cancelBid, selectTempBid } from 'data/bids/Bids.actions';
import {
  fetchGaragesData,
  clearGaragesData,
} from 'data/garages/Garages.actions';
import { fetchParty, clearCurrentParty } from 'data/parties/Parties.actions';
import { showAlert } from 'data/app/App.actions';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      addedAuctionComment: state.auctions.addedAuctionComment,
      auction: state.auctions.currentAuction,
      bids: state.auctions.currentAuctionBids,
      comments: state.auctions.currentAuctionComments,
      fetchingImages: state.auctions.fetchingImages,
      lang: state.i18n.locale,
      selectingTempBid: state.bids.selectingBid,
      selectedTempBid: state.bids.selectedBid,
      garageData: (state.garages.garagesData || [])[0],
      merchantData: state.parties.currentParty,
      insuranceData: state.parties.currentParty,
      images: state.auctions.images,
      loading:
        state.auctions.fetchingCurrentAuction ||
        state.auctions.fetchingCurrentAuctionBids,
      message: state.auctions.message || {},
      submitting:
        state.auctions.addingAuctionComment ||
        state.auctions.creatingAuction ||
        state.auctions.editingAuction ||
        state.auctions.startingAuctions ||
        state.auctions.endingAuction ||
        state.auctions.acceptingAuction ||
        state.auctions.dispatchingAuction ||
        state.auctions.rejectingAuction ||
        state.auctions.cancellingAuctions ||
        state.auctions.creatingAuctionBids ||
        state.bids.cancelingBid,
      user: state.app.user,
    },
    state,
    'auctionStatuses',
    'bidStatuses',
    'vehicleTypes',
    'partTypes',
    'partyTypes',
    'regions',
    'taxOffices',
    'countries',
    'fuelTypes',
    'gearBoxes',
    'wheelDrives',
    'bidFileTypes',
    'imitationPartCategories',
    'usedConditionTypes',
    'applications',
    'memberships'
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    createBid: (auctionId, bidData) =>
      dispatch(createAuctionBids(auctionId, bidData)),
    //createBid: (auctionId, partTypeId, amount, comments) => dispatch(createAuctionBids(auctionId, [{ PartTypeID: partTypeId, Amount: amount, Comments: comments }])),
    cancelBid: bidId => dispatch(cancelBid(bidId)),
    fetchAuction: () => dispatch(fetchAuction(ownProps.params?.id)),
    fetchBids: () => dispatch(fetchBidsForAuction(ownProps.params?.id)),
    fetchComments: () => dispatch(fetchComments(ownProps.params?.id)),
    startAuction: (auctionData, comments) =>
      dispatch(startAuctions([auctionData], comments)),
    commentAuction: (auctionId, auctionStatusId, comments) =>
      dispatch(commentAuction(auctionId, auctionStatusId, comments)),
    clearCommentAuction: () => dispatch(clearCommentAuction()),
    endAuction: (bidId, garageData) => dispatch(endAuction(bidId, garageData)),
    selectTempBid: bidId => dispatch(selectTempBid(bidId)),
    acceptAuction: auctionId => dispatch(acceptAuction(auctionId)),
    dispatchAuction: (auctionId, isNotDispatch, comments) =>
      dispatch(dispatchAuction(auctionId, isNotDispatch, comments)),
    rejectAuction: (auctionId, comments) =>
      dispatch(rejectAuction(auctionId, comments)),
    cancelAuction: auctionId => dispatch(cancelAuctions([auctionId])),

    fetchGarage: garageId => dispatch(fetchGaragesData(garageId)),
    fetchMerchant: merchantId => dispatch(fetchParty(merchantId)),
    fetchInsurance: insuranceId => dispatch(fetchParty(insuranceId)),

    fetchImages: folderId => dispatch(fetchImages(folderId)),

    showAlert: (text, type, duration) => showAlert(text, type, duration),

    clearData: () => {
      dispatch(clearCurrentAuction());
      dispatch(clearAuctionBids());
      dispatch(clearCurrentParty());
      dispatch(clearGaragesData());
      dispatch(clearImages());
      dispatch(clearCommentAuction());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuctionDetail);
